import React, { useEffect, useState } from 'react';
import { Clock3Icon, EyeIcon, SparklesIcon } from 'lucide-react';
interface OfferTime {
  day: string;
  hours: string;
  minutes: string;
  seconds: string;
}
function getOfferTime(): OfferTime {
  const now = new Date();
  const midnight = new Date(now);
  midnight.setHours(24, 0, 0, 0);
  const seconds = Math.floor(Math.max(0, midnight.getTime() - now.getTime()) / 1000);
  return {
    day: new Intl.DateTimeFormat('en-US', {
      weekday: 'long'
    }).format(now).toUpperCase(),
    hours: String(Math.floor(seconds / 3600)).padStart(2, '0'),
    minutes: String(Math.floor(seconds % 3600 / 60)).padStart(2, '0'),
    seconds: String(seconds % 60).padStart(2, '0')
  };
}
export function TodayOfferCard() {
  const [offerTime, setOfferTime] = useState<OfferTime>(getOfferTime);
  useEffect(() => {
    const timer = window.setInterval(() => setOfferTime(getOfferTime()), 1000);
    return () => window.clearInterval(timer);
  }, []);
  return <aside aria-label="Information about today's offer" className="mt-4 overflow-hidden rounded-2xl border border-gold bg-navy-mid px-4 py-4 text-white shadow-[0_14px_30px_-18px_rgba(0,0,0,0.8)] sm:px-5" data-id="element-194" data-mp="j6tgrzur875f">
      <div className="flex flex-col items-center gap-3 text-center sm:flex-row sm:justify-between sm:gap-5 sm:text-left" data-id="element-195" data-mp="s79jv87l5c9r">
        <div className="min-w-0" data-id="element-196" data-mp="n86qil0ywuhm">
          <span className="inline-flex items-center gap-1.5 rounded-full border border-gold/60 bg-gold/10 px-2.5 py-1 text-[11px] font-bold tracking-[0.12em] text-gold" data-id="element-197" data-mp="n980sna5tcya">
            <SparklesIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-198" data-mp="3rnoc8u982p9h" /> TODAY&apos;S OFFER AVAILABLE
          </span>
          <p className="mt-2 text-xs font-medium uppercase tracking-[0.18em] text-white/65" data-id="element-199" data-mp="9a8cjgqk702n">
            {offerTime.day}
          </p>
          <p className="mt-1 text-sm leading-snug text-white/85" data-id="element-200" data-mp="4g43mrxqghyx">
            This offer ends at midnight tonight, based on your local time zone.
          </p>
        </div>
        <div className="flex shrink-0 items-center gap-3" role="timer" aria-live="off" data-id="element-201" data-mp="37ydvre1nk0ab">
          <Clock3Icon className="hidden h-5 w-5 text-gold sm:block" aria-hidden="true" data-id="element-202" data-mp="1buzqf96rv3ay" />
          <TimeUnit value={offerTime.hours} label="HRS" data-id="element-203" data-mp="1gtb09jx2hdt6" />
          <span className="pb-4 font-display text-2xl font-bold text-gold" data-id="element-204" data-mp="1llcbr3mev0i5">:</span>
          <TimeUnit value={offerTime.minutes} label="MIN" data-id="element-205" data-mp="1lnonv05hmgna" />
          <span className="pb-4 font-display text-2xl font-bold text-gold" data-id="element-206" data-mp="1qj40jorre6i4">:</span>
          <TimeUnit value={offerTime.seconds} label="SEC" data-id="element-207" data-mp="sxgb5ntq0og3" />
        </div>
      </div>
      <div className="mt-3 flex items-center justify-center gap-2 border-t border-gold/25 pt-3 text-center text-xs text-white/65 sm:justify-start" data-id="element-208" data-mp="xv83uk26welc">
        <EyeIcon className="h-3.5 w-3.5 shrink-0 text-gold" aria-hidden="true" data-id="element-209" data-mp="12tjdouship3k" />
        <span data-id="element-210" data-mp="16x7m1foxxopv">Review today&apos;s offer before it ends.</span>
      </div>
    </aside>;
}
function TimeUnit({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="flex min-w-[38px] flex-col items-center" data-id="element-211" data-mp="2ib1x1i8wi5yq">
      <span className="font-display text-3xl font-bold leading-none text-gold sm:text-4xl" data-id="element-212" data-mp="2idft9ufbho7v">
        {value}
      </span>
      <span className="mt-1 text-[10px] font-semibold tracking-[0.13em] text-white/55" data-id="element-213" data-mp="2mwhhw9zvb84">
        {label}
      </span>
    </div>;
}